import { Fragment } from "react"

export default function DetailView({className, rowData, labelClass, contentClass}) {
    return (
        <div className={`${className}`}>
            {rowData?.map((r, index) => {
                if (!r.hide) {
                    return (
                        <Fragment key={index}>
                            <div className={labelClass}>{r.label}</div>
                            <div className={contentClass}>{r.content}</div>
                        </Fragment>
                    )
                }
            })}
        </div>
    )
}

/*
use

<DetailView
    className="grid grid-cols-3"  //should be a grid
    labelClass="text-right border-b"
    contentClass="col-span-2"
    hide={true}
    rowData = {[
        {
            label: "Some Label",
            content: {<div>Some content</div>},
            hide: true,
        }, 
        {
            ...
        }
    ]}
/>

*/